'use client';

import { c as _c } from "react/compiler-runtime";
import { useSliderPosition } from '@/hooks/useSliderPosition';
import { useCallback, useRef } from 'react';
import styles from './ImageComparisonSlider.module.scss';
const ImageComparisonSlider = t0 => {
  const $ = _c(48);
  const {
    beforeImage,
    afterImage,
    beforeLabel: t1,
    afterLabel: t2,
    instructions: t3
  } = t0;
  const beforeLabel = t1 === undefined ? "Before" : t1;
  const afterLabel = t2 === undefined ? "After" : t2;
  const instructions = t3 === undefined ? "Drag to compare" : t3;
  const containerRef = useRef(null);
  const {
    sliderPosition,
    setSliderPosition,
    setIsDragging
  } = useSliderPosition(containerRef);
  let t4;
  if ($[0] !== setSliderPosition) {
    t4 = e => {
      if (e.key === "ArrowLeft") {
        e.preventDefault();
        setSliderPosition(_temp);
      } else {
        if (e.key === "ArrowRight") {
          e.preventDefault();
          setSliderPosition(_temp2);
        }
      }
    };
    $[0] = setSliderPosition;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const handleKeyDown = t4;
  let t5;
  if ($[2] !== setIsDragging) {
    t5 = () => setIsDragging(true);
    $[2] = setIsDragging;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const handleMouseDown = t5;
  let t6;
  if ($[4] !== setIsDragging) {
    t6 = () => setIsDragging(true);
    $[4] = setIsDragging;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const handleTouchStart = t6;
  let t7;
  if ($[6] !== sliderPosition) {
    t7 = Math.round(sliderPosition);
    $[6] = sliderPosition;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== afterImage || $[9] !== afterLabel) {
    t8 = <img src={afterImage} alt={afterLabel} className={styles.slider__image} draggable="false" loading="lazy" />;
    $[8] = afterImage;
    $[9] = afterLabel;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== afterLabel || $[12] !== sliderPosition) {
    t9 = sliderPosition < 95 && <div className={`${styles.slider__label} ${styles["slider__label--after"]}`}>{afterLabel}</div>;
    $[11] = afterLabel;
    $[12] = sliderPosition;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t8 || $[15] !== t9) {
    t10 = <div className={`${styles.slider__imageLayer} ${styles["slider__imageLayer--after"]}`}>{t8}{t9}</div>;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const t11 = `${sliderPosition}%`;
  let t12;
  if ($[17] !== t11) {
    t12 = {
      width: t11
    };
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  const t13 = `polygon(0 0, ${sliderPosition}% 0, ${sliderPosition}% 100%, 0 100%)`;
  let t14;
  if ($[19] !== t13) {
    t14 = {
      clipPath: t13
    };
    $[19] = t13;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== beforeImage || $[22] !== beforeLabel || $[23] !== t14) {
    t15 = <img src={beforeImage} alt={beforeLabel} className={styles.slider__image} style={t14} draggable="false" loading="lazy" />;
    $[21] = beforeImage;
    $[22] = beforeLabel;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== beforeLabel || $[26] !== sliderPosition) {
    t16 = sliderPosition > 5 && <div className={`${styles.slider__label} ${styles["slider__label--before"]}`}>{beforeLabel}</div>;
    $[25] = beforeLabel;
    $[26] = sliderPosition;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t12 || $[29] !== t15 || $[30] !== t16) {
    t17 = <div className={`${styles.slider__imageLayer} ${styles["slider__imageLayer--before"]}`} style={t12}>{t15}{t16}</div>;
    $[28] = t12;
    $[29] = t15;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  const t18 = `${sliderPosition}%`;
  let t19;
  if ($[32] !== t18) {
    t19 = {
      left: t18
    };
    $[32] = t18;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className={styles.slider__handle} role="button" aria-label="Drag to adjust comparison"><div className={styles["slider__handle-icon"]}><div className={styles["slider__handle-icon-bar"]} /><div className={styles["slider__handle-icon-bar"]} /></div></div>;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t19) {
    t21 = <div className={styles.slider__divider} style={t19}>{t20}</div>;
    $[35] = t19;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== instructions) {
    t22 = <div id="slider-instructions" className={styles.slider__instructions}><span>{instructions}</span></div>;
    $[37] = instructions;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== handleKeyDown || $[40] !== handleMouseDown || $[41] !== handleTouchStart || $[42] !== t10 || $[43] !== t17 || $[44] !== t21 || $[45] !== t22 || $[46] !== t7) {
    t23 = <div className={styles.slider}><div ref={containerRef} className={styles.slider__container} onMouseDown={handleMouseDown} onTouchStart={handleTouchStart} onKeyDown={handleKeyDown} tabIndex={0} role="slider" aria-label="Before and After Image Comparison Slider" aria-valuemin={0} aria-valuemax={100} aria-valuenow={t7} aria-describedby="slider-instructions">{t10}{t17}{t21}{t22}</div></div>;
    $[39] = handleKeyDown;
    $[40] = handleMouseDown;
    $[41] = handleTouchStart;
    $[42] = t10;
    $[43] = t17;
    $[44] = t21;
    $[45] = t22;
    $[46] = t7;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  return t23;
};
export default ImageComparisonSlider;
function _temp(prev) {
  return Math.max(0, prev - 5);
}
function _temp2(prev_0) {
  return Math.min(100, prev_0 + 5);
}